import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		'stepSize':     { type: Number,  default: 1    },
		'onlyPositive': { type: Boolean, default: true }
	}

	connect() {
	}

	increment(event) {
		const currentValue = this.getIntegerOrDefault(this.inputTarget.value, 0)
		const newValue = currentValue + this.stepSizeValue
		this.inputTarget.value = newValue
	}

	decrement(event) {
		const currentValue = this.getIntegerOrDefault(this.inputTarget.value, 0)
		let newValue = currentValue - this.stepSizeValue
		if (this.onlyPositiveValue && newValue < 0) newValue = 0
		this.inputTarget.value = newValue
	}

	getIntegerOrDefault(stringValue, defaultValue) {
		let intValue = parseInt(stringValue)
		if (Number.isNaN(intValue)) intValue = defaultValue
		if (intValue < 0) intValue = 0
		return intValue
	}
}

